import React from 'react';
import { UltimoKm } from '../services/ultimoKm';

/**
 * Sob o campo de km: de onde veio o valor que ja esta preenchido, e o aviso
 * quando o que foi digitado e menor. Dizer a origem ("abastecimento em 14/09")
 * e o que permite a quem digita julgar se e o painel que esta certo ou o
 * registro anterior.
 */
const DicaUltimoKm: React.FC<{ ultimo: UltimoKm | null; erro: string | null; carregando?: boolean }> = ({
  ultimo,
  erro,
  carregando = false,
}) => {
  if (erro) {
    return <p className="mt-1 text-xs text-red-600">{erro}</p>;
  }
  if (carregando) {
    return <p className="mt-1 text-xs text-gray-500">Buscando o último km do painel...</p>;
  }
  if (!ultimo) {
    return null;
  }

  return (
    <p className="mt-1 text-xs text-gray-500">
      Último registro do painel: {ultimo.descricao}. Pode ser maior, não menor.
    </p>
  );
};

export default DicaUltimoKm;
